// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const numel: PokeData = {
  "id": 322,
  "name": "numel",
  "height": 7,
  "weight": 240,
  "base_experience": 61,
  "types": [
    PokeType.FIRE,
    PokeType.GROUND
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "double-edge",
    "growl",
    "ember",
    "flamethrower",
    "earthquake",
    "focus-energy",
    "amnesia",
    "flame-wheel",
    "curse",
    "magnitude",
    "yawn",
    "earth-power",
    "lava-plume",
    "flame-burst",
    "incinerate",
    "bulldoze"
  ],
  "moves": [
    "tackle",
    "growl",
    "ember",
    "flamethrower",
    "earthquake",
    "curse",
    "magnitude",
    "earth-power",
    "fire-fang",
    "blaze-kick",
    "flare-blitz",
    "mud-bomb",
    "mud-slap"
  ],
  "evolution_chain": {
    "id": 162,
    "item": null,
    "species": [
      {
        "name": "numel",
        "order": 350,
        "types": [
          PokeType.FIRE,
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "camerupt",
        "order": 351,
        "types": [
          PokeType.FIRE,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 322,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 33,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 51.25,
    "speed": 35,
    "ability_power": 65
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
